export const hospitalAccountNotesColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'earliest_service_from_date',
  'fk_hospital__data_doc_new_id',
  'guarantor_account_number',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'note',
  'note_type',
  'posting_time',
  'sequence_number',
  'snapshot_id',
  'transaction__post_date',
  'transaction__transaction_amount',
  'transaction__transaction_code',
  'transaction__transaction_code_description',
  'transaction__transaction_id',
  'user_id',
];
